module.exports = __webpack_public_path__ + "img/naturturismforetagen-logo.732c5f35.svg";